import { DEFAULT_TITLE } from '../const'

export const consumo = [
  {
    name: 'gastos_consumo',
    path: '/consumos',
    component: () => import('@/views/public/consumo/'),
    meta: {
      title: `${DEFAULT_TITLE} | Gastos de Consumo`
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/public/consumo.js